import LiteralsService from 'src/services/literals/LiteralsService';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { goToTransactions } from 'src/services/router.service';
import Anchor from 'src/components/atomic/atoms/anchor/Anchor';
import adobeTags from 'src/types/adobe-tags';
import Selectors from 'src/utils/selectors';
import useCurrentUser from 'src/hooks/useCurrentUser';
import { IconLeft } from '@americanexpress/dls-react';
import { DLSSize } from 'src/types/dls-size.enum';
import { DlsTypographyVariants } from 'src/types/dls-typography-variants.enum';
import styles from './transactionDetailsBackAnchor.module.scss';
import { BudgetPages } from 'src/components/atomic/pages/BudgetPages';
import UrlHelper from 'src/utils/url.helper';

export default function BackAnchor(): JSX.Element {
    const history = useHistory();
    const location = useLocation();
    const { isFullPlanUser } = useCurrentUser();

    const previousPage = location.state?.from;
    const previousSearch = location.state?.search;

    return (
        <Anchor
            onClick={() => {
                if (previousPage?.includes('transactions')) history.goBack();
                else goToTransactions(isFullPlanUser, history);
            }}
            tag={adobeTags.Transactions.Details.Back}
            href={
                previousPage?.includes('transactions')
                    ? UrlHelper.buildUrl(previousPage, previousSearch)
                    : BudgetPages.TRANSACTIONS
            }
            className={`${styles.backLink} ${DlsTypographyVariants.BODY_1}`}
            data-cy={Selectors.Transactions.DETAILS_BACK_LINK}
            inline
        >
            <IconLeft size={DLSSize.SMALL} />
            {LiteralsService.getLiteral('TransactionDetails.back')}
        </Anchor>
    );
}
